import { Link, Navigate } from 'react-router-dom';
import { Disclosure, Menu, Transition } from '@headlessui/react';
import { useDispatch, useSelector } from 'react-redux';
import { logoutUserAction } from '@/js/reduxstore/actions/authActions';
import { UserRound, Search, Bell } from 'lucide-react';
import { LogOut, Settings, User as UserIcon } from 'lucide-react';
import { Menu as MenuIcon, X as XIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
// Old code - uses headlessui/react
// New code - uses shadcn

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}
export default function SupplierNavbar() {
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const user = useSelector((state) => state?.authReducer?.userData);
  const role = user?.role;

  const { isLoggedIn } = useSelector((state) => state.authReducer);

  const navigation = [
    {
      name: 'search',
      icon: Search,
      to: '#',
    },
    {
      name: 'notification',
      icon: Bell,
      to: '#',
    },
  ];

  const handleLogout = () => {
    dispatch(logoutUserAction());
    navigate('/');

    // trigger a refresh to clear the user data
    window.location.reload();
  };
  // If the user is not logged in, redirect them away from the supplier navbar
  if (!isLoggedIn) {
    return <Navigate to="/" replace />;
  }

  const navbarClasses = classNames(
    'text-[15px] font-robo rounded-none shadow-none sm:px-6 bg-white',
  );

  return (
    <Disclosure as="nav" className={navbarClasses}>
      {({ open }) => (
        <>
          <div className="py-3 z-20">
            <div className="relative flex flex-col sm:flex-row items-center justify-between">
              {/* Mobile menu button */}
              <div className="absolute inset-y-0 left-0 flex items-center sm:hidden">
                <Disclosure.Button className="inline-flex items-center justify-center rounded-md p-2 text-black hover:bg-[#8D8D8D] hover:text-black focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white">
                  <span className="sr-only">Open main menu</span>
                  {open ? (
                    <XIcon className="block h-6 w-6" aria-hidden="true" />
                  ) : (
                    <MenuIcon className="block h-6 w-6" aria-hidden="true" />
                  )}
                </Disclosure.Button>
              </div>

              {/* Logo Section */}
              <div className="flex flex-row items-center justify-center space-x-2">
                <Link
                  to={`/${user?.route ? user?.route : ''}`}
                  className="w-auto h-auto"
                >
                  <img
                    className="h-10 w-10"
                    src="/blackLogo.svg"
                    alt="Makersharks"
                  />
                </Link>
                <Link
                  to="/"
                  className="text-[22px] text-center font-semibold sm:text-left"
                >
                  MakerSharks
                </Link>
              </div>

              {/* Desktop Menu Icons on the right */}
              <div className="hidden sm:flex sm:justify-end space-x-3 pr-1 items-center">
                {navigation.map((item) => (
                  <Link
                    key={item.name}
                    to={item.to}
                    className="rounded-lg text-center mx-1 p-2 hover:bg-purple-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white transition ease-in-out duration-500"
                  >
                    <item.icon
                      className="h-6 w-6 text-black"
                      aria-hidden="true"
                    />
                  </Link>
                ))}

                {/* User Dropdown */}
                <Menu as="div" className="relative z-20">
                  <div>
                    <Menu.Button className="rounded-lg text-center mx-1 p-2 hover:bg-purple-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white transition ease-in-out duration-500">
                      <UserRound
                        className="h-6 w-6 text-black"
                        aria-hidden="true"
                      />
                    </Menu.Button>
                  </div>

                  <Transition
                    enter="transition ease-out duration-100"
                    enterFrom="transform opacity-0 scale-95"
                    enterTo="transform opacity-100 scale-100"
                    leave="transition ease-in duration-75"
                    leaveFrom="transform opacity-100 scale-100"
                    leaveTo="transform opacity-0 scale-95"
                  >
                    <Menu.Items className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                      {role && (
                        <Menu.Item>
                          {({ active }) => (
                            <Link
                              to={`/${role}/dashboard`}
                              className={classNames(
                                active ? 'bg-gray-100' : '',
                                'flex items-center px-4 py-2 text-sm text-gray-700',
                              )}
                            >
                              <UserIcon className="mr-2 h-4 w-4" />
                              Dashboard
                            </Link>
                          )}
                        </Menu.Item>
                      )}
                      {/* <Menu.Item>
                        {({ active }) => (
                          <Link
                            to="#"
                            className={classNames(
                              active ? 'bg-gray-100' : '',
                              'flex items-center px-4 py-2 text-sm text-gray-700',
                            )}
                          >
                            <Settings className="mr-2 h-4 w-4" />
                            Settings
                          </Link>
                        )}
                      </Menu.Item> */}
                      <Menu.Item>
                        {({ active }) => (
                          <button
                            onClick={handleLogout}
                            className={classNames(
                              active ? 'bg-gray-100' : '',
                              'w-full text-left flex items-center px-4 py-2 text-sm text-gray-700',
                            )}
                          >
                            <LogOut className="mr-2 h-4 w-4" />
                            Logout
                          </button>
                        )}
                      </Menu.Item>
                    </Menu.Items>
                  </Transition>
                </Menu>
              </div>
            </div>
          </div>

          {/* Mobile Menu Panel */}
          <Disclosure.Panel className="sm:hidden">
            <div className="space-y-1 px-4 pb-3 pt-2">
              {navigation.map((item) => (
                <Disclosure.Button
                  key={item.name}
                  as={Link}
                  to={item.to}
                  className={classNames(
                    'text-black',
                    'block rounded-full px-3 py-2 text-base',
                  )}
                >
                  {item.name}
                </Disclosure.Button>
              ))}

              {/* Mobile User Menu Items */}
              <div className="pt-4 pb-3 border-t border-gray-200">
                <div className="space-y-1">
                  <Disclosure.Button
                    as={Link}
                    to="/profile"
                    className="block rounded-full px-3 py-2 text-base text-black"
                  >
                    Profile
                  </Disclosure.Button>
                  <Disclosure.Button
                    as={Link}
                    to="/settings"
                    className="block rounded-full px-3 py-2 text-base text-black"
                  >
                    Settings
                  </Disclosure.Button>
                  <Disclosure.Button
                    onClick={handleLogout}
                    className="block rounded-full px-3 py-2 text-base text-black"
                  >
                    Logout
                  </Disclosure.Button>
                </div>
              </div>
            </div>
          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
  );
}

// export default function SupplierNavbar() {
//   const dispatch = useDispatch();
//   const user = useSelector((state) => state?.authReducer?.userData);

//   const navigation = [
//     // {
//     //   name: 'shark-coin',
//     //   icon: 'CustomIcon',
//     //   to: '#',
//     // },
//     {
//       name: 'search',
//       icon: Search,
//       to: '#',
//     },
//     {
//       name: 'notification',
//       icon: Bell,
//       to: '#',
//     },
//     {
//       name: 'profile',
//       icon: UserRound,
//       to: '#',
//     },
//   ];

//   const navbarClasses = classNames(
//     'text-[15px] font-robo rounded-none shadow-none sm:px-6 bg-white'
//   );

//   return (
//     <Disclosure as="nav" className={navbarClasses}>
//       {({ open }) => (
//         <>
//           <div className="py-3">
//             <div className="relative flex flex-col sm:flex-row items-center justify-between">
//               {/* Mobile menu button*/}
//               <div className="absolute inset-y-0 left-0 flex items-center sm:hidden">
//                 <Disclosure.Button className="inline-flex items-center justify-center rounded-md p-2 text-black hover:bg-[#8D8D8D] hover:text-black focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white">
//                   <span className="sr-only">Open main menu</span>
//                   {open ? (
//                     <XMarkIcon className="block h-6 w-6" aria-hidden="true" />
//                   ) : (
//                     <Bars3Icon className="block h-6 w-6" aria-hidden="true" />
//                   )}
//                 </Disclosure.Button>
//               </div>

//               {/* Logo Section */}
//               <div className="flex flex-row items-center justify-center space-x-2">
//                 <Link
//                   // this to points to the user's route i.e /supplier
//                   to={`/${user?.route ? user?.route : ''}`}
//                   // to={'/'}
//                   className="w-auto h-auto"
//                 >
//                   <img
//                     className="h-10 w-10"
//                     src="/blackLogo.svg"
//                     alt="Makersharks"
//                   />
//                 </Link>
//                 <Link
//                   to="/"
//                   className="text-[22px] text-center font-semibold sm:text-left"
//                 >
//                   MakerSharks
//                 </Link>
//               </div>

//               {/* Desktop Menu Icons on the right */}
//               <div className="hidden sm:flex sm:justify-end space-x-3 pr-1">
//                 {navigation.map((item) => (
//                   <Link
//                     key={item.name}
//                     to={item.to}
//                     className="rounded-lg text-center mx-1 p-2 hover:bg-purple-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white transition ease-in-out duration-500"
//                     aria-current={item.current ? 'page' : undefined}
//                   >
//                     <item.icon
//                       className="h-6 w-6 text-black"
//                       aria-hidden="true"
//                     />
//                   </Link>
//                 ))}
//               </div>
//             </div>
//           </div>

//           {/* Mobile Menu Panel */}
//           <Disclosure.Panel className="sm:hidden">
//             <div className="space-y-1 px-4 pb-3 pt-2">
//               {navigation.map((item) => (
//                 <Disclosure.Button
//                   key={item.name}
//                   as={Link}
//                   to={item.to}
//                   className={classNames(
//                     'text-black',
//                     'block rounded-full px-3 py-2 text-base'
//                   )}
//                   aria-current={item.current ? 'page' : undefined}
//                 >
//                   {item.name}
//                 </Disclosure.Button>
//               ))}
//             </div>
//           </Disclosure.Panel>
//         </>
//       )}
//     </Disclosure>
//   );
// }
